import classNames from "classnames";
import React from "react";
import { WidgetInputMultipleButtons, WidgetInputProps } from "../../types";
import { InputButton } from "../radioButtonsInput/inputButton";
import styles from "../styles.css";
import { WidgetInputLabel } from "@fidget/common/components/chat/widgetInputLabel/widgetInputLabel";

interface Props extends WidgetInputProps {
  input: WidgetInputMultipleButtons;
}
export const MultipleButtonsInput = ({ input, isSubmitted, onChange, userAnswers }: Props) => {
  const handleChange = (isSelected: boolean, value: string) => {
    const currentValues = userAnswers[input.name]?.values || [];
    if (isSelected) {
      onChange({ inputName: input.name, values: currentValues.filter((v) => v !== value) });
    } else {
      onChange({ inputName: input.name, values: [...currentValues, value] });
    }
  };

  return (
    <div>
      <WidgetInputLabel text={input.displayName} />
      <div
        className={classNames(styles.options, {
          [styles.column]: input.style === "vertically_aligned"
        })}
      >
        {input.buttons.map((b) => {
          const isSelected =
            !!userAnswers[input.name]?.values &&
            !!userAnswers[input.name]!.values?.find((v) => v === b.value);

          return (
            <InputButton
              key={b.value}
              disabled={isSubmitted}
              onClick={() => handleChange(isSelected, b.value)}
              primary={isSelected}
            >
              {b.displayName}
            </InputButton>
          );
        })}
      </div>
    </div>
  );
};
